






























































































































































































































































































































































































































































































































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DemoServer from "../../shared/DemoServer";
import DateFormatter from "../../shared/DateFormatter";
import OverlayWindow from "../general/OverlayWindow.vue";
import PointerMenu from "../general/PointerMenu.vue";
import Loading from "../general/Loading.vue";
import CategoryTypeInput from "../general/CategoryTypeInput.vue";
import ImageSelectBase64 from "../general/ImageSelectBase64.vue";
import OverlayPictureViewer from "../general/OverlayPictureViewer.vue";

import SettingsJson from "../../shared/SettingsJson";
import CategoryTypeJson from "../../shared/CategoryTypeJson";
import { CategoryTypeType } from "../../shared/CategoryTypeType";
import ClientJson, { defaultClientJson } from "../../shared/ClientJson";
import { ClientStatus, ClientStatusNames } from "../../shared/ClientStatus";
import { AccountStatus, AccountStatusNames } from "../../shared/AccountStatus";
import ContactJson, { defaultContactJson } from "../../shared/ContactJson";
import MailingRecipientJson, { defaultMailingRecipientJson } from "../../shared/MailingRecipientJson";
import MailingListJson from "../../shared/MailingListJson";
import { MailingRecipientStatus, MailingRecipientStatusNames } from "../../shared/MailingRecipientStatus";
import SepaMandateJson from "../../shared/SepaMandateJson";
import { Gender } from "../../shared/Gender";
import { CreatedBy } from "../../shared/CreatedBy";

import { UserPermissionRank } from "../../shared/UserPermissionRank";
import ModulesJson, { checkModuleIsActivated } from "../../shared/ModulesJson";

import { ValidationResult, Validation } from "../../shared/Validation";
import { validateClientJson, validateClientJsonAddNew } from "../../shared/ClientJson";
import FormContact from "../general/FormContact.vue";
import FormSepaMandate from "../general/FormSepaMandate.vue";

import RentalBookingDetails from "../rental/RentalBookingDetails.vue";

export default Vue.extend({
  name: "ClientsClientDetails",
  components: {
    OverlayWindow,
    PointerMenu,
    Loading,
    CategoryTypeInput,
    FormContact,
    FormSepaMandate,
    RentalBookingDetails,
    ImageSelectBase64,
    OverlayPictureViewer
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    settings: Object as PropType<SettingsJson>,
    allActiveModules: Array as PropType<ModulesJson[]>,
    userActiveModules: Array as PropType<ModulesJson[]>,
    clientId: Number,
    mode: String,
  },
  data() {
    return {
      DemoServer: DemoServer,
      DateFormatter: DateFormatter,
      Gender: Gender,
      CategoryTypeType: CategoryTypeType,
      ClientStatus: ClientStatus,
      ClientStatusNames: ClientStatusNames,
      AccountStatus: AccountStatus,
      AccountStatusNames: AccountStatusNames,
      MailingRecipientStatus: MailingRecipientStatus,
      MailingRecipientStatusNames: MailingRecipientStatusNames,
      CreatedBy: CreatedBy,
      checkModuleIsActivated: checkModuleIsActivated,
      supportsDatePicker: false,
      editable: false as boolean,
      detailsTitle: "",
      UserPermissionRank: UserPermissionRank,
      detailsMode: "",
      selectedRentalBookingId: null as number | null,
      selectedClientId: null as number | null,
      details: null as ClientJson | null,
      allMailingLists: null as MailingListJson[] | null,
      useMailings: false as Boolean,
      useAccount: false as Boolean,
      useSepaMandate: false as boolean,
      hidePassword: true as boolean,
      password: "" as string,
      overlayPictureViewerImgUrl: null as string | null,
      hasChanges: false,
      hintChanged: {
        state: false as boolean,
      },
      frontendValidations: {
        username: false,
        password: false,
      },
      usernameTimeout: null as any,
      toValidate: {} as any,
      validation: null as ValidationResult<ClientJson> | null,
      submitValidation: false as boolean,
      loadingGeneral: false as boolean,
      loadingUsernameAvailability: false as boolean,
    };
  },
  created() {
    this.initDetails();
  },
  mounted() {
    this.checkDatePickerSupport();
  },
  methods: {
    initDetails() {
      this.selectedClientId = this.clientId;
      this.loadDetails();

      this.selectDetailsMode(this.mode);
    },

    setCachedData() {
      this.$nextTick(() => {
        this.hasChanges = false;
      });
    },

    checkDatePickerSupport() {
      let testvalue = "a";
      var ele = <HTMLInputElement>this.$refs["testDatePicker"];

      if (ele != null) {
        ele.value = testvalue;

        if (ele.value !== testvalue) {
          this.supportsDatePicker = true;
        }
      }
    },

    async loadMailingLists() {
      if (this.restClient != null) {
        try {
          this.allMailingLists = await this.restClient.getMailingLists();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadDetails() {
      if (this.selectedClientId != null) {
        if (this.restClient != null) {
          try {
            this.details = await this.restClient.getClient(this.selectedClientId);

            if (this.details.mailingRecipient != null) {
              this.useMailings = true;
              this.loadMailingLists();
            }

            if (this.details.username != null) {
              this.useAccount = true;
            }

            if (this.details.sepaMandate != null) {
              this.useSepaMandate = true;
            }
          } catch (e) {
            alert(e.message);
          }
        }
      } else {
        this.details = this.getDefaultClientData();

        this.details.state = ClientStatus.active;
        this.details.createdBy = CreatedBy.management;
      }

      this.setCachedData();
      this.hasChanges = false;
    },

    getDefaultClientData(): ClientJson {
      return defaultClientJson();
    },

    getDefaultContact(): ContactJson {
      return defaultContactJson();
    },

    getDefaultSepaMandate(): SepaMandateJson {
      return {
        ID: null,
        dateTime: new Date().toISOString(),
        lastUseDateTime: new Date().toISOString(),
        accountHolderFirstName: this.details && this.details.contact ? this.details.contact.firstName : "",
        accountHolderLastName: this.details && this.details.contact ? this.details.contact.lastName : "",
        addressStreet: this.details && this.details.contact ? this.details.contact.addressStreet : "",
        addressZip: this.details && this.details.contact ? this.details.contact.addressZip : "",
        addressCity: this.details && this.details.contact ? this.details.contact.addressCity : "",
        addressCountry: this.details && this.details.contact ? this.details.contact.addressCountry : "",
        IBAN: "",
        BIC: "",
      };
    },

    //START set cached data

    //END set cached data

    selectDetailsMode(mode: string) {
      this.resetHintChanged();

      switch (mode) {
        case "add":
          this.detailsMode = "add";
          this.detailsTitle = "Person hinzufügen";
          this.editable = true;
          break;

        case "edit":
          this.detailsMode = "edit";
          this.detailsTitle = "Person bearbeiten";
          this.editable = true;
          break;

        default:
          this.detailsMode = "read";
          this.detailsTitle = "Person";
          this.editable = false;
          break;
      }
    },

    toggleEditMode() {
      this.editable = !this.editable;
    },

    resetHintChanged() {
      let k = this.hintChanged;
      let i: keyof typeof k;

      for (i in this.hintChanged) {
        this.hintChanged[i] = false;
      }
    },

    stopEditMode() {
      if (!this.hasChanges) {
        //todo: use $refs
        document.getElementsByClassName("overlay-window-scroll")[0].scrollTo(0, 0);
        this.selectDetailsMode("show");
        this.hasChanges = false;
        this.loadDetails();
      } else {
        let c = confirm("Sie haben Änderungen vorgenommen. Durch Klicken auf OK gehen diese Änderungen verloren.");
        if (c == true) {
          document.getElementsByClassName("overlay-window-scroll")[0].scrollTo(0, 0);
          this.selectDetailsMode("show");
          this.hasChanges = false;
          this.loadDetails();
        } else {
          //do nothing
        }
      }
    },

    closeDetails() {
      if (!this.hasChanges) {
        this.$emit("closeOverlay");
      } else {
        let c = confirm("Sie haben Änderungen vorgenommen. Durch Klicken auf OK gehen diese Änderungen verloren.");
        if (c == true) {
          this.$emit("closeOverlay");
        } else {
          //do nothing
        }
      }
    },

    inputValidation(key: any, prop: any) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      if (this.details != null) {
        this.validation = validateClientJson(this.details);
      }

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    },

    /* START frontend validation */

    async frontendValidation() {
      await this.checkUsernameAvailability();
      this.validatePassword();
    },

    async checkUsernameAvailability() {
      this.loadingUsernameAvailability = true;
      clearTimeout(this.usernameTimeout);

      let vue = this;

      this.usernameTimeout = setTimeout(async function () {
        if (vue.details != null && vue.details.username != null && vue.details.username != "") {
          let rc = RestClient;
          try {
            let availability: boolean = await rc.getUsernameAvailability(vue.details.username);
            vue.frontendValidations.username = !availability;
            vue.loadingUsernameAvailability = false;
          } catch (err) {
            alert(err.message);
            vue.loadingUsernameAvailability = false;
          }
        } else {
          vue.frontendValidations.username = false;
          vue.loadingUsernameAvailability = false;
        }
      }, 600);
    },

    validatePassword() {
      if (this.useAccount && this.password == "") {
        this.frontendValidations.password = true;
      } else {
        this.frontendValidations.password = false;
      }
    },

    checkFrontendValidations() {
      let check = true;

      let k = this.frontendValidations;
      let i: keyof typeof k;
      for (i in this.frontendValidations) {
        if (this.frontendValidations[i] == true) {
          check = false;
        }
      }

      return check;
    },

    /* END frontend validation */

    toggleUseMailings() {
      if (this.details != null) {
        if (this.useMailings) {
          this.details.mailingRecipient = null;
          this.useMailings = false;
        } else {
          this.loadMailingLists();
          this.details.mailingRecipient = defaultMailingRecipientJson();
          this.details.mailingRecipient!.mailingLists = [];
          this.useMailings = true;
        }
      }
    },

    toggleUseAccount() {
      if (this.details != null) {
        if (this.useAccount) {
          this.details.username = null;
          this.useAccount = false;
        } else {
          this.details.username = "";
          this.password = "";
          this.useAccount = true;
        }
      }
    },

    toggleUseSepaMandate() {
      if (this.details != null) {
        if (this.useSepaMandate) {
          this.details.sepaMandate = null;
          this.useSepaMandate = false;
        } else {
          this.details.sepaMandate = this.getDefaultSepaMandate();
          this.useSepaMandate = true;
        }
      }
    },

    //START set input data (where data be cached)

    //END set input data (where data be cached)

    addRelative() {
      if (this.details != null) {
        if (this.details.relatives == null) {
          this.details.relatives = [];
        }
        this.details.relatives.push(this.getDefaultContact());
      }
    },

    deleteRelative(index: number) {
      if (this.details != null && this.details.relatives != null) {
        this.details.relatives.splice(index, 1);

        delete this.toValidate["relative-" + index];
      }
    },

    async addNewClient() {
      if (this.details != null) {
        this.loadingGeneral = true;
        this.submitValidation = true;

        await this.frontendValidation();
        this.validation = validateClientJsonAddNew(this.details);

        if (this.validation != null && this.validation.isValid == true && this.checkFrontendValidations()) {
          try {
            this.details = await this.restClient.addClient(this.details);
            if (this.details != null) {
              this.selectedClientId = this.details.ID;

              if (this.details.username != null) {
                await this.changePassword();
              }

              this.hasChanges = false;
              this.loadingGeneral = false;
              this.closeDetails();
              alert("Die Daten wurden erfolgreich hinzugefügt.");
            }
          } catch (e) {
            this.loadingGeneral = false;
            alert(e.message);
          }
        } else {
          this.loadingGeneral = false;
          //todo Validation Error anzeigen
          alert("Die Daten konnte nicht hinzugefügt werden. Bitte überprüfen Sie Ihre Angaben.");
        }
      }
    },

    async saveClientDetails() {
      if (this.details != null) {
        if (this.hasChanges) {
          this.loadingGeneral = true;
          this.submitValidation = true;

          //todo ###START
          //todo: Validation muss durchgeführt werden (siehe hier) ->AUCH bei SettingsDetails
          this.validation = validateClientJson(this.details);
          //todo ###END

          if (this.validation != null && this.validation.isValid == true && this.checkFrontendValidations()) {
            if (this.details.username != null && this.password != "") {
              await this.changePassword();
            }

            if (this.restClient != null) {
              try {
                let updatedDetails = await this.restClient.updateClient(this.details);

                this.hasChanges = false;
                this.loadingGeneral = false;
                this.submitValidation = false;
                this.stopEditMode();

                //TODO: Validation error loest alert auch aus -> prüfen
                alert("Die Änderungen wurden erfolgreich gespeichert.");
              } catch (e) {
                this.loadingGeneral = false;
                alert(e.message);
              }
            }
          } else {
            this.loadingGeneral = false;
            alert("Die Änderungen konnten nicht gespeichert werden. Bitte überprüfen Sie Ihre Änderungen.");
          }
        } else {
          alert("Es wurden keine Änderungen vorgenommen.");
        }
      }
    },

    async deleteClient() {
      if (this.selectedClientId != null) {
        let c = confirm("Wollen Sie diese Daten wirklich unwiderruflich löschen?");
        if (c == true) {
          if (this.restClient != null) {
            try {
              await this.restClient.deleteClient(this.selectedClientId);
              this.closeDetails();
              alert("Die Daten wurden erfolgreich gelöscht.");
            } catch (e) {
              alert(e.message);
            }
          }
        } else {
          //do nothing
        }
      }
    },

    async changePassword() {
      if (this.selectedClientId != null) {
        if (this.restClient != null) {
          try {
            await this.restClient.clientChangePassword(this.selectedClientId, this.password);

            this.password = "";
          } catch (e) {
            alert(e.message);
          }
        }
      }
    },

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },
  },

  watch: {
    details: {
      handler(val, oldVal) {
        if (oldVal != null) {
          this.hasChanges = true;
        }
      },
      deep: true,
    },

    password: {
      handler() {
        this.hasChanges = true;
      },
    },

    selectedRentalBookingId: {
      handler(val, oldVal) {
        if (val == null) {
          this.details = null;
          this.loadDetails();
        }
      },
    },
  },

  computed: {
    permissionAble: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    selectedDeletedRentalTypes() {
      let filteredRentalTypes: string[] = [];

      if (this.details != null) {
        filteredRentalTypes = this.details.rentalTypes;
        filteredRentalTypes = filteredRentalTypes.filter((i: string) => {
          if (this.settings != null) {
            if (!this.settings.rentalAccountTypes.includes(i)) {
              return i;
            }
          }
        });
      }

      return filteredRentalTypes;
    },

    getRecipientMailingListNames(): string | undefined {
      if (
        this.details != null &&
        this.details.mailingRecipient != null &&
        this.details.mailingRecipient.mailingLists != null
      ) {
        let mailingListNames = [];

        for (let i = 0; i < this.details.mailingRecipient.mailingLists.length; i++) {
          mailingListNames.push(this.details.mailingRecipient.mailingLists[i].name);
        }

        if (mailingListNames.length <= 0) {
          return "Keiner Liste zugeordnet";
        } else {
          return mailingListNames.join(", ");
        }
      }
    },

    username: {
      get(): string | null | undefined {
        if (this.details != null) {
          return this.details.username;
        }
      },
      set(value: string) {
        if (this.details != null) {
          if (value == "") {
            this.details.username = null;
          } else {
            this.details.username = value;
          }
        }
      },
    },
  },
});
